import { render, staticRenderFns } from "./InventorySelecter.vue?vue&type=template&id=230f06e2"
import script from "./InventorySelecter.vue?vue&type=script&lang=js"
export * from "./InventorySelecter.vue?vue&type=script&lang=js"
import style0 from "./InventorySelecter.vue?vue&type=style&index=0&id=230f06e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports